import { useEffect, useRef } from "react";
import { useStore } from "./store/Store";
import { Mesh } from "three";
import React from "react";
import { ACTION_TRIGGERS } from "./ActionTriggers";

export type Object3DProps = {
  name: string;
  bloom?: boolean;
  physicsShape?: "concave" | "convex" | "box" | "sphere" | "hull" | "none";
  collisionFlag?: 0 | 1 | 2 | 4;
  singleRigidBody?: boolean;
  mass?: number;
  clickable?: boolean;
} & any;

const Object3D = (props: Object3DProps) => {
  const triggerAction = useStore((store) => store.triggerAction);
  const addAsset = useStore((store) => store.addAsset);
  const ref = useRef(null);

  const physics = useStore((store) => store.physics);

  useEffect(() => {
    if (!physics || props.physicsShape === "none") return;
    if (props.singleRigidBody) {
      physics?.add.existing(ref.current as any, {
        shape: props.physicsShape || "box",
        collisionFlags: props.collisionFlag || 0,
        mass: props.mass || 1,
      });
    } else {
      (ref.current! as any).traverse((mesh: any) => {
        if ((mesh as Mesh).isMesh) {
          physics?.add.existing(mesh as any, {
            shape: props.physicsShape || "box",
            collisionFlags: props.collisionFlag || 0,
            mass: props.mass || 1,
          });
        }
      });
    }
  }, [
    ref,
    physics,
    props.singleRigidBody,
    props.physicsShape,
    props.collisionFlag,
    props.mass,
  ]);

  useEffect(() => {
    addAsset(ref, props.name);
  }, [ref, props.name, addAsset]);

  return (
    <mesh
      {...props}
      ref={ref}
      onClick={(event: any) => {
        if (!props.clickable) return;
        event.stopPropagation();
        // console.log("event", event, ref);
        triggerAction(
          ACTION_TRIGGERS.TAP,
          props.customTarget ? props.customTarget : props.name,
          event.object.name,
          {
            name: props.name,
            ref,
          }
        );
      }}
    >
      {props.children}
    </mesh>
  );
};

export default Object3D;
